type BrandLockupProps = {
  suffix?: string
}

/**
 * Wordmark. The pixel face is limited to this and to eyebrow micro-labels
 * (appendix A §A2). The blinking block is the same activity indicator the sweep
 * bar uses, and it stops under `prefers-reduced-motion`.
 */
export function BrandLockup({ suffix }: BrandLockupProps) {
  return (
    <>
      <span className="cursor-block" aria-hidden="true" />
      <span aria-hidden="true">NEARMETAL</span>
      {suffix ? <span className="mono-label" aria-hidden="true">{suffix}</span> : null}
    </>
  )
}
